import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Snackbar, Slide } from '@mui/material';
import MuiAlert from '@mui/material/Alert';

function TransitionDown(props) {
  return <Slide {...props} direction="down" />;
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Create the Snackbar context
const SnackBarContext = createContext();

// Custom hook to access the Snackbar context
export const useSnackBar = () => {
  return useContext(SnackBarContext);
};

// SnackBarProvider component to wrap your application with
export function SnackBarProvider({ children }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    message: '',
    typ: 'success',
  });

  // Function to show the Snackbar
  const showSnackbar = (arg1, arg2 = 'success') => {
    const severities = ['success', 'error', 'warning', 'info'];
    let actualMsg, actualTyp;

    if (severities.includes(arg1)) {
      // Swapped signature: showSnackbar(severity, msg)
      actualTyp = arg1;
      actualMsg = typeof arg2 === 'string' ? arg2 : '';
    } else {
      // Standard signature: showSnackbar(msg, severity)
      actualMsg = typeof arg1 === 'string' ? arg1 : '';
      actualTyp = severities.includes(arg2) ? arg2 : 'success';
    }

    setSnackbarMessage({ message: actualMsg, typ: actualTyp });
    setSnackbarOpen(true);
  };

  // Function to hide the Snackbar
  const hideSnackbar = () => {
    setSnackbarOpen(false);
  };

  return (
    <SnackBarContext.Provider value={{ snackbarOpen, snackbarMessage, showSnackbar, hideSnackbar }}>
      {children}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1500}
        onClose={hideSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={TransitionDown}
      >
        <Alert onClose={hideSnackbar} severity={snackbarMessage.typ} sx={{ minWidth: 300, fontWeight: 900, borderRadius: 2 }}>
          {snackbarMessage.message}
        </Alert>
      </Snackbar>
    </SnackBarContext.Provider>
  );
}

SnackBarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
